import React, { FC } from 'react';
import { Route, Switch, useHistory } from 'react-router';

import { isConfigurationReady, isDashboardEnabled } from 'src/common/helpers/ConfigurationHelpers';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { NotFound404Page } from 'src/common/pages/not-found-404-page/NotFound404Page';
import { useConfiguration } from 'src/common/providers/configurationProvider/ConfigurationProvider';
import { TableStateProvider } from 'src/common/providers/dashboard/TableStateProvider';

import { DashboardLayout } from '../components/dashboard-layout/DashboardLayout';
import { handleDashboardRedirection } from '../helpers/NavigationHelpers';
import { DashboardBusinessUnits } from '../pages/business-units/DashboardBusinessUnits';
import { AccessibilityDashboard } from '../pages/dashboard/Dashboard';
import { IssuesPage } from '../pages/issues/IssuesPage';

export const WebDashboardRoot: FC = () => {
	const history = useHistory();
	const { configuration } = useConfiguration();

	if (!isConfigurationReady(configuration)) {
		return null;
	}

	if (!isDashboardEnabled(configuration)) {
		handleDashboardRedirection(history, configuration);
		return null;
	}

	return (
		<DashboardLayout>
			<TableStateProvider>
				<Switch>
					<Route
						exact
						path={RoutesHelper.getAccessibilityDashboardPath()}
						component={AccessibilityDashboard}
					/>
					<Route exact path={RoutesHelper.getDashboardIssuesPath()} component={IssuesPage} />
					<Route
						exact
						path={RoutesHelper.getBusinessUnitDashboardPath()}
						component={DashboardBusinessUnits}
					/>
					<Route
						path={RoutesHelper.getBusinessUnitDashboardPath(':unitId')}
						component={DashboardBusinessUnits}
					/>
					<Route render={() => <NotFound404Page />} />
				</Switch>
			</TableStateProvider>
		</DashboardLayout>
	);
};
